import { CardPosition } from './MiroAnnotations';

interface MiroAnnotationCardProps {
  index: number;
  text: string;
  cardPos: CardPosition;
  cardWidth: number;
  onClose: () => void;
}

/**
 * Cadre d'annotation individuel — Design "Amber Bubble"
 * Fond amber avec badge numéroté pour visibilité maximale.
 * Position fixed calculée par MiroAnnotations.
 */
export function MiroAnnotationCard({ index, text, cardPos, cardWidth, onClose }: MiroAnnotationCardProps) {
  return (
    <div
      data-miro-card="true"
      style={{
        position: 'fixed',
        left: Math.max(8, cardPos.left),
        top: Math.max(8, cardPos.top),
        maxWidth: '220px',
        zIndex: 61,
        pointerEvents: 'auto',
      }}
      className="animate-miro-fade-in"
    >
      <div
        className="
          relative
          bg-amber-500 text-black
          rounded-xl
          px-3.5 py-3
          shadow-[0_8px_32px_rgba(0,0,0,0.4)]
          text-[12.5px] font-medium
          leading-[1.45]
        "
      >
        {/* Bouton fermer — stoppe la propagation pour ne pas déclencher le dismiss global */}
        <button
          onClick={e => {
            e.stopPropagation();
            onClose();
          }}
          aria-label="Fermer l'annotation"
          className="
            absolute -top-2 -right-2
            w-5 h-5 rounded-full
            bg-black/20 hover:bg-black/40
            flex items-center justify-center
            text-black/60 hover:text-black
            text-xs transition-colors
          "
        >
          ×
        </button>

        {/* Contenu avec badge numéroté */}
        <div className="flex items-start gap-2">
          <span className="flex-shrink-0 w-5 h-5 rounded-full bg-black text-amber-500 text-[10px] font-extrabold flex items-center justify-center mt-0.5">
            {index}
          </span>
          <span>{text}</span>
        </div>
      </div>
    </div>
  );
}
